import React, { useEffect, useState } from 'react'
import '../../css/homepage.css'
import WelcomeImg from '../../Images/HR/BODMember/NageshPokharel.jpg'
import ServiceSlider from './ServiceSlider'
import Newspage from './Newspage'
import BranchesPage from './BranchesPage'
import FAQPage from './FAQPage'
import TestimonialPage from './TestimonialPage'
import ImageSlider from './ImageSlider'
import Aos from 'aos'
import Notice from '../Notice/Notice'

const Homepage = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const [timedPopup, setTimedPopup] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setTimedPopup(true);
        }, 1000);
        setTimeout(() => {
            setTimedPopup(false);
        }, 25000);
    }, [])

    return (
        <>

            <div>
                <Notice trigger={timedPopup} setTrigger={setTimedPopup} />
            </div>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='image-slider-section' data-aos='fade-right'>
                        <ImageSlider />
                    </div>
                    <div className='welcome-title' data-aos='fade-right'>
                        <h2><span>नमस्कार</span></h2>
                    </div>
                    <div className='welcome-body'>
                        <div className="welcome-text" data-aos='fade-right'>
                            <p>हाम्रो वेवसाइटमा यहाँहरुलाई हार्दिक स्वागत गर्दछौं ।<br />आज सम्म आउदा हामीमा आत्मविश्वास बढाउने र निरन्तर सहयोग गर्नुहुने यहाँहरु जस्तै वेवसाइट भिजिर्टसहरु, विभिन्न संघ संस्था, शुभचिन्तक तथा शेयर सदस्यहरुप्रति हामी आभारी छौं । यहाँहरुको प्रत्यक्ष अप्रत्यक्ष सहयोगहरु हाम्रो इतिहासमा स्वर्ण अक्षरले लेखिनेछन । आगामी दिनहरुमा पनि यहाँहरुको निरन्तर माया र सहयोग पाइरहने अपेक्षा गरिरहेका छौं । हामी यहाँहरुलाई अझै गुणस्तरीय र प्रभावकारी सेवा प्रदान गर्ने प्रतिवद्धता व्यक्त गर्दछौ ।<br /><b>नागेश पोखरेल</b><br /><b>अध्यक्ष</b></p>
                            <a href="/aboutus/home" className="theme-btn read-more">Read More</a>
                        </div>
                        <div className='welcome-image' data-aos='fade-right'>
                            <img src={WelcomeImg} alt='welcome-image' />
                        </div>
                    </div>
                    <div className='branches-section' data-aos='fade-right'>
                        <BranchesPage />
                    </div>
                    <div className='service-slider-section' data-aos='fade-right'>
                        <ServiceSlider />
                    </div>
                    <div className='news-slider-section' data-aos='fade-right'>
                        <Newspage />
                    </div>
                    <div className='faq-section' data-aos='fade-right'>
                        <FAQPage />
                    </div>
                    <div className='testimonial-section' data-aos='fade-right'>
                        <TestimonialPage />
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>

        </>
    )
}

export default Homepage